import React from 'react';

export const DataDeletionPage = () => {
    const languages = [
        {
            code: 'en',
            dir: 'ltr',
            title: "Account and Data Deletion",
            desc: "In accordance with Google Play policies, you can request the deletion of your account and associated data.",
            how: "How to proceed?",
            step: "Send an email to support@gpschoolbus.com with your School ID.",
            data: "Deleted data: Profile, GPS history, Student list.",
            delay: "Processing time: 7 business days."
        },
        {
            code: 'fr',
            dir: 'ltr',
            title: "Suppression du compte et des données",
            desc: "Conformément aux règles de Google Play, vous pouvez demander la suppression de vos données.",
            how: "Comment procéder ?",
            step: "Envoyez un email à support@gpschoolbus.com avec votre School ID.",
            data: "Données supprimées : Profil, Historique GPS, Liste des élèves.",
            delay: "Délai de traitement : 7 jours ouvrés."
        },
        {
            code: 'es',
            dir: 'ltr',
            title: "Eliminación de cuenta y datos",
            desc: "De acuerdo con las políticas de Google Play, puede solicitar la eliminación de sus datos.",
            how: "¿Cómo proceder?",
            step: "Envíe un correo electrónico a support@gpschoolbus.com con su ID de escuela.",
            data: "Datos eliminados: Perfil, historial de GPS, lista de estudiantes.",
            delay: "Tiempo de procesamiento: 7 días hábiles."
        },
        {
            code: 'ar',
            dir: 'rtl',
            title: "حذف الحساب والبيانات",
            desc: "وفقًا لسياسات Google Play، يمكنك طلب حذف بياناتك.",
            how: "كيفية القيام بذلك؟",
            step: "أرسل بريدًا إلكترونيًا إلى support@gpschoolbus.com مع معرف المدرسة الخاص بك.",
            data: "البيانات المحذوفة: الملف الشخصي، سجل الموقع (GPS)، قائمة الطلاب.",
            delay: "مدة المعالجة: 7 أيام عمل."
        }
    ];

    return (
        <div style={{ 
            padding: '20px', 
            maxWidth: '900px', 
            margin: '0 auto', 
            fontFamily: 'sans-serif',
            backgroundColor: '#f8fafc'
        }}>
            <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                <img src="/dark-4x.png" alt="Logo" style={{ width: '100px' }} />
                <h1 style={{ color: '#2d3748' }}>Data Deletion Request / Demande de suppression</h1>
            </div>

            {languages.map((lang) => (
                <div key={lang.code} style={{ 
                    direction: lang.dir as any,
                    textAlign: lang.dir === 'rtl' ? 'right' : 'left',
                    background: 'white',
                    padding: '30px',
                    borderRadius: '20px',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
                    marginBottom: '30px',
                    border: '1px solid #e2e8f0'
                }}>
                    <h2 style={{ color: '#2d3748', borderBottom: '2px solid #ffc107', display: 'inline-block', paddingBottom: '5px' }}>
                        {lang.title}
                    </h2>
                    <p style={{ fontSize: '1.1rem', marginTop: '15px' }}>{lang.desc}</p>
                    
                    <div style={{ background: '#fff5f5', padding: '15px', borderRadius: '10px', margin: '20px 0', borderLeft: lang.dir === 'ltr' ? '5px solid #e53e3e' : 'none', borderRight: lang.dir === 'rtl' ? '5px solid #e53e3e' : 'none' }}>
                        <h3 style={{ marginTop: 0, color: '#e53e3e' }}>{lang.how}</h3>
                        <p><strong>{lang.step}</strong></p>
                    </div>

                    <p><strong>{lang.data}</strong></p>
                    <p style={{ color: '#718096', fontSize: '0.9rem' }}>{lang.delay}</p>
                </div>
            ))}
            
            <footer style={{ textAlign: 'center', padding: '20px', color: '#a0aec0' }}>
                &copy; 2026 GPSchoolBus - Safety & Privacy
            </footer>
        </div>
    );
};